import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
	useState,
	useEffect,
	useContext,
	useRef,
	createRef,
	useCallback,
	useMemo,
} from 'react';

import { Form, Radio, Button, Skeleton, message, Modal, Popover } from 'antd';
import { DownOutlined, UpOutlined, InfoCircleOutlined } from '@ant-design/icons'

import Router from 'next/router';
import { CopyOutlined, CreditCardOutlined } from '@ant-design/icons';
import Image from 'next/image'


const FormItem = Form.Item;
import classnames from 'classnames';
import Container from '@/components/H5PC/Layout/Container/Container';
import OrderInfo from '@/components/H5PC/Components/OrderInfo/index';
import Card from '@/components/H5PC/Components/Card';
import UnionPay from '@/components/H5PC/Components/UnionPay';
import PIXBOL from '@/components/H5PC/Components/PIXBOL';
import KPAY from '@/components/H5PC/Components/KPAY'
import Klarna from '@/components/H5PC/Components/Klarna';

import AlipayQrLink from '@/components/H5PC/Components/Alipay+/AlipayQrLink';

import LinkPay from '@/components/H5PC/Components/Alipay+/LinkPay'
import CommonQrcode from '@/components/H5PC/Components/CommonQrcodeOrLink/QrcodePay';
import CommonLink from '@/components/H5PC/Components/CommonQrcodeOrLink/LinkPay';
import CommonQrcodeOrLink from '@/components/H5PC/Components/CommonQrcodeOrLink';
import Evonet from '@/components/H5PC/Components/Evonet'
import { SUBSCRIPTION_ALLOWED_CARD_BRANDS } from '@/components/Common/constants';

import CashierApplePayButton from '@/components/H5PC/Components/CashierApplePayButton';
import CashierGooglePayButton from '@/components/H5PC/Components/CashierGooglePayButton';


import myContext from '@/utils/createContext';
import { resCodeMsg } from '@/components/resCodeMsg';
import { riskCreateJs, getSessionId } from '@/components/Common/riskCreateJs';
import {
	getInitCardInfo,
	paymentPayflow,
	paymentPollingQuery,
	paymentResultQuery,
	getCashierApplePayInfo,
	getCashierGooglePayInfo,
} from '@/components/H5PC/service';

import { getInitProductsOrder } from '@/components/H5PC/service/index';
import { getDomainStr } from '@/components/H5PC/utils'

import bankCardAttribution from '@/components/Common/bankCardOfChina.js';
import QueryString from 'query-string';
import { getUrlPrefix, getEnv, gtag, formatCardHolderIdNoVal, getPaymentData, isEmptyObject, reportEventToMonitor } from '@/utils/index';
import MessageModal from '@/components/H5PC/Components/MessageModal';
import NodeRSA from 'node-rsa';
import _ from 'lodash';
import LockLoading from '@/components/LockLoading/index';
import Tds from '@/components/H5PC/Components/Tds';

import { CommonError } from '@/components/H5PC/CommonMethod.js'

import ThemePc from '@/components/H5PC/Components/CustomTheme/ThemePc';
import ThemeMobile from '@/components/H5PC/Components/CustomTheme/ThemeMobile';
import ProductsInfo from '@/components/H5PC/Components/CustomTheme/ProductsInfo';
import ProductsZD from '@/components/H5PC/Components/CustomTheme/ProductsZD';

import ExchangeRate from '@/components/H5PC/Form/ExchangeRate'

import VFooter from '@/components/H5PC/Layout/Footer/vIndex'

import { sessionStorage, getUrlParams } from '@/utils'

import {
	CommonHandleSubmit,
	CommonHandleCancelPayment,
	CommonJudgePaymentStatus,
	CommonTestCode,
	paySuccussHref
} from '@/components/H5PC/CommonMethod';

const ALIPAY_TYPE = ['DANA', 'BPI', 'RABBIT_LINE_PAY', 'BOOST', 'ALIPAY_CN', 'ALIPAY_HK', 'GCASH', 'KAKAOPAY', 'TNG', 'TRUEMONEY']

const WAFFO_TYPE = ['GCASH', 'PAYMAYA', 'GRABPAY', 'COINSPH', 'TWN_BANK', 'JKOPAY', 'ZALOPAY', 'VIETQR', 'NAPASCARD']

//微信直连支付方式
const WXHK_TYPE = ['WECHATPAY']

// 直接跳转的支付类型
const DIRECT_JUMP_TYPE = ['PEZ', 'KBA', 'KON']

/**
 * 判断是否为直接跳转类型或 PC 端重定向类型
 * 包含: PEZ, KBA, KON, ALIPAY_TYPE, AFTERPAY, WAFFO_TYPE, WXHK_TYPE
 */
const isDirectJumpOrPcRedirectType = (radioValue, isMobileView) => {
	const isDirectJump = DIRECT_JUMP_TYPE.includes(radioValue);
	const isAlipayType = ALIPAY_TYPE.includes(radioValue);
	const isWaffoType = WAFFO_TYPE.includes(radioValue);
	const isWxhkType = WXHK_TYPE.includes(radioValue);
	const isAfterpay = radioValue === 'AFTERPAY';

	const isPcRedirect = !isMobileView && (isAlipayType || isAfterpay || isWaffoType || isWxhkType);
	
	return isDirectJump || isPcRedirect;
}

/**
 * 判断是否为移动端重定向类型
 * 包含: ALIPAY_TYPE, AFTERPAY, WAFFO_TYPE, WXHK_TYPE (移动端)
 */
const isMobileRedirectType = (radioValue, isMobileView) => {
	const isAlipayType = ALIPAY_TYPE.includes(radioValue);
	const isWaffoType = WAFFO_TYPE.includes(radioValue);
	const isWxhkType = WXHK_TYPE.includes(radioValue);
	const isAfterpay = radioValue === 'AFTERPAY';

	return isMobileView && (isAlipayType || isAfterpay || isWaffoType || isWxhkType);
}

function CreditCard(props) {
	const intl = props.intl;
	const { formatMessage } = intl;
	const containerRef = useRef(null);
	const addressRef = useRef();
	const { resData, isMobileView, key, cashierLastResponseCode, infoData } = useContext(myContext);
	const h5OrWeb = isMobileView ? 'H5' : 'WEB';
	let [initData, setInitData] = useState({});
	let [initProductsOrder, setInitProductsOrder] = useState({})

	let [payActualPaymentAmount, setPayActualPaymentAmount] = useState('')
	let [payActualPaymentCurrency, setPayActualPaymentCurrency] = useState('')


	// 用于迅联支付的操作
	const [actionType, setActionType] = useState([])
	const [paymentLen, setPaymentLen] = useState('')
	const [showMore, setShowMore] = useState(false)
	const [orderStatus, setOrderStatus] = useState('')

  
	let [returnUrl, setReturnUrl] = useState('')
	const [body, setBody] = useState('')
	const [method, setMethod] = useState('post')

	const [origin, setOrigin] = useState('')

	/** 收银台 Apple Pay / Google Pay（非 iframe） */
	const [applePayConfigInfoBeanData, setApplePayConfigInfoBeanData] = useState(null);
	const [googlePayConfigInfoBean, setGooglePayConfigInfoBean] = useState(null);
	const [isButtonVisibleGP, setIsButtonVisibleGP] = useState(null);

	const btnRef = useRef()




	const cashierData = isEmptyObject(infoData) ? resData : infoData || {};

	console.log('VINDEX', cashierData)

	let { orderServiceChargeAmount, merchantServiceChargeModel, orderServiceChargeRate } = cashierData || '';
	const { ablePaymentCurrencyList } = cashierData || [];
	const ablePaymentCurrencyListBoolean = ablePaymentCurrencyList && ablePaymentCurrencyList.length > 0 ? true : false;

	let { merchantTheme } = cashierData || {};


	let {
		payments,
		actualPaymentAmount,
		actualPaymentCurrency,
		email,
		lastResponseCode,
		showEuropeFlag,
		companyAddress,
		companyName,
	} = cashierData;

	// 订阅模式下过滤 ICR 卡组只保留 V/M
	const isSubscription = cashierData?.paymentMode === 'subscription';
	if (isSubscription && payments) {
		payments.forEach(item => {
			if (item.paymentMethod === 'ICR') {
				item.cardBrands = item.cardBrands.filter(
					brand => SUBSCRIPTION_ALLOWED_CARD_BRANDS.includes(brand)
				);
			}
		});
	}

	let paymentMethod = [];
	for (let i = 0; i < payments.length; i++) {
		paymentMethod.push(payments[i].paymentMethod);
	}
	// 处理RSA验证失效
	const myTokenRef = useRef('');
	const myPublicKeyRef = useRef('');

	// 处理domain
	const showDomain = getDomainStr(resData)
	// 获取文字颜色
	const { fontColor, mainColor } = merchantTheme || '#40a9ff';

	// 初始化radio，根据后端返回的数据显示和隐藏payments
	// const myRadioValue = paymentMethod[0] && paymentMethod[0].toLowerCase();
	const [radioValue, setRadioValue] = useState(paymentMethod[0]);
	const [payflowRes, setPayflowRes] = useState({
		tdsInfo: { nextStep: 'DEVICE' },
	});
	// 类型这个字段很重要，千万别重名
	const [type, setType] = useState('');

	// let type;

	useEffect(() => {
		/********
		 * 修改背景颜色, 修改底部的footer
		 * */
		// const dd = document.getElementsByTagName('body');
		// dd[0].style.cssText = 'background-color: #fff';
		// document.getElementById('vh5pc').style.cssText = 'background-color: #fff';

		const footerHtml = document.getElementById('h5-footer');
		footerHtml ? footerHtml.remove() : null;


		const type = paymentMethod[0]?.toLowerCase();
		localStorage.setItem('paymentMethod', type)
		setType(type);

		// 初始化订单信息
		fetchInitProductsOrder(type)


		// 隐藏显示逻辑
		if (paymentMethod.length === 1) {
			setRadioValue(paymentMethod[0]);
		}


		let newActionType = []
		// 判断第一种支付方式是否为迅联支付
		for (let i = 0; i < payments.length; i++) {
			if (payments[i]?.channelCodes?.[0].indexOf('EVO') != -1) {
				newActionType.push('EVO')
			} else if (payments[i]?.channelCodes?.[0].indexOf('WAFFO') != -1) {
				newActionType.push('WAFFO')
			} else if (payments[i]?.channelCodes?.[0].indexOf('WXHK') != -1) {
				newActionType.push('WXHK')
			} else {
				newActionType.push('')
			}
		}
		setActionType(newActionType)
		if (payments.length > 5) {
			setShowMore(false)
		}

		setPaymentLen(payments.length)

		// 获取跳转链接
		setOrigin(window?.location?.origin)

		//导入风控指纹js
		riskCreateJs();

	}, []);

	useEffect(() => {
		const type = paymentMethod[0] && paymentMethod[0].toLowerCase();

		fetchInitData(type, false);

		// 获取支付结果
		if (!isEmptyObject(resData)) {
			checkPaymentResult()
		}

	}, [resData])

	const fetchInitData = async (type, radioType) => {
		const urlPrefix = getUrlPrefix();

		let res = getPaymentData(type, radioType && !isEmptyObject(resData) ? resData : cashierData, resData);

		const redirectUrl = res && res.data && res.data.redirectUrl;
		if (redirectUrl) {
			if (redirectUrl.indexOf('http') > -1) {
				window.location.href = redirectUrl;
			} else {
				window.location.href = `${urlPrefix}${redirectUrl}`;
			}
		} else {

			getCardName(res && res.data, type);
			getCardNo(res && res.data, type);

			setInitData(res && res.data);

			// 计算页面加载完成时间
			const pageTime = new Date().getTime() - Number(localStorage.getItem('llPay_startTime'));

			if (!sessionStorage.getItem('pageTime')) {
				gtag(`${showDomain}支付页面`, [new Date() + '页面加载时间', pageTime]);
				gtag(`${showDomain}支付页面`, ['页面加载时间', pageTime]);
				gtag(`定制支付页面`, ['页面加载时间', pageTime]);
				sessionStorage.setItem('pageTime', pageTime)
			}


			if (ablePaymentCurrencyListBoolean) {
				const data = ablePaymentCurrencyList[0];
				setPayActualPaymentAmount(data && data.amount || '0.00');
				setPayActualPaymentCurrency(data && data.targetCurrencyName || '');

			} else {
				const data = res && res.data;
				setPayActualPaymentAmount(data && data.actualPaymentAmount || '');
				setPayActualPaymentCurrency(data && data.actualPaymentCurrency || '');
			}


			// 判断支付成功失败
			CommonJudgePaymentStatus(props, res && res.data, isMobileView);
		}
	};

	const fetchInitProductsOrder = async type => {
		// const resOrder = await getInitProductsOrder(type, key);

		// setInitProductsOrder(resOrder && resOrder.data)
	}

	let cardName = '';

	const getWalletCardName = (data) => {
		const { cardName, cardFirstName, cardLastName } = data || {};
		const first = (cardFirstName || '').trim();
		const last = (cardLastName || '').trim();
		const fullName = (first && last) ? `${first} ${last}` : '';
		return (cardName || '').trim() || fullName || last || first || '';
	};

	const getCardName = (data, type) => {
		// 设置cardName
		let {
			cardName,
			cardFirstName,
			cardLastName,
		} = data || '';

		let name1 = ''; // name1 用来拼接cardFirstName, cardLastName， name2 用来做 firstName/lastName

		cardFirstName = cardFirstName ? cardFirstName : '';
		cardLastName = cardLastName ? cardLastName : '';

		if (cardFirstName || cardLastName) {
			name1 = cardFirstName.trim() + ' ' + cardLastName.trim(); // 去前后空格，然后拼接
		} else {
			name1 = '';
		}
		//  设置cardName ， 填充到input
		cardName = cardName || name1.trim() || cardLastName.trim() || cardFirstName.trim() || ''; // 移除前后空格

		if (type === "icr" || type === 'pix' || type === 'bol') {
			form.setFieldsValue({ cardName });
		} else {
			form.setFieldsValue({ cardName: '' });
		}
	}

	let cardHolderIdNo = '';

	const getCardNo = (data, type) => {
		let {
			cardHolderIdNo = ''
		} = data || {};
		if (type === 'pix' || type === 'bol') {
			form.setFieldsValue({
				cardHolderIdNo: formatCardHolderIdNoVal(cardHolderIdNo)
			});
		}
	}

	let {
		publicKey,
		token,
	} = resData || {};


	let {

		cardCountry,
		cardLine1,
		cardLine2,
		cardCity,
		cardState,
		cardPostcode,
		cardDistrict,
	} = initData || {}

	// 仅在 resData 提供了 publicKey/token 且 ref 还没被其他 info 接口更新时，才初始化
	if (token && !myTokenRef.current) {
		myTokenRef.current = token;
	}
	if (publicKey && !myPublicKeyRef.current) {
		myPublicKeyRef.current = publicKey;
	}


	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [validateTrigger, setValidateTrigger] = useState('onSubmit'); // 默认为submit时候校验
	const [myLastResponseCode, setMyLastResponseCode] = useState(
		cashierLastResponseCode || lastResponseCode || '', // _.isEmpty的对数字判断为空；_.isEmpty(1111) ==> true,所以不能用于判断数字
	); // 默认为submit时候校验

	// MessageModal组件中用到
	const [msgModalCardNo, setMsgModalCardNo] = useState('');
	const [msgModalPhoneNum, setMsgModalPhoneNum] = useState('');
	const [bankCode, setBankCode] = useState('');
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [validateKey, setValidateKey] = useState('');
	const [myActualPaymentAmount, setMyActualPaymentAmount] = useState('');
	const [
		myActualPaymentCurrencySymbol,
		setMyActualPaymentCurrencySymbol,
	] = useState('');
	const [
		myActualPaymentCurrency,
		setMyActualPaymentCurrency,
	] = useState('');

	useEffect(() => {
		if (validateTrigger === 'onChange') {
			// 更改错误提示的多语言
			form.validateFields();
		}
	}, [intl.locale]);
	/**
	 * 支付
	 *
	 */
	const onFinish = async values => {
		// todo @埋点
		gtag(`${showDomain}支付页面`, [new Date() + '点击支付,Form校验成功']);
		gtag(`${showDomain}支付页面`, ['点击支付,Form校验成功']);
		gtag(`定制支付页面`, ['点击支付,Form校验成功']);


		if (!myPublicKeyRef.current) {
			message.warning(formatMessage({ id: 'ga-checkout.netword-slow' }));
			return;
		}
		// console.log(values);
		// return;
		// 参数
		let params = {};
		params = {
			...values,
			key,
		};
		// 只有信用卡需要过期日期
		if (radioValue === 'ICR') {
			params.cardName = values.cardName && values.cardName.trim(); // 去除卡姓名前后空格
			params.cardExpirationMonth = values.cardExpiryDate.substr(0, 2);
			params.cardExpirationYear = '20' + values.cardExpiryDate.substr(3, 4);

			// 移除name中的0-9及特殊字符`,
			params.cardName = values.cardName && values.cardName.replace(/(\d|\`|\,)/g, '');
			// 若city全部为数字，则置为NULL
			const allNumberReg = /^[0-9]*$/;
			if (allNumberReg.test(values.cardCity)) {
				params.cardCity = 'NULL';
			}
			if (ablePaymentCurrencyListBoolean) {
				params.amount = payActualPaymentAmount;
				params.currency = payActualPaymentCurrency;
				delete params['exchange-rate'];
			}
			if (!Boolean(params.cardCvv) || params?.cardCvv === '***'){
				delete params['cardCvv'];
			}
		}
		if (radioValue === 'LCR') {
			params.cardName = values.cardName && values.cardName.trim(); // 去除卡姓名前后空格
			params.cardExpirationMonth = values.cardExpiryDate.substr(0, 2);
			params.cardExpirationYear = '20' + values.cardExpiryDate.substr(3, 4);
			params.cardHolderIdType = 'CPF'; // 巴西类型是CPF
			// 巴西指纹采集
			params.sessionId = sessionStorage.getItem('sessionId') || '';
		}


		if (radioValue === 'PIX' || radioValue === 'BOL') {
			const _length = values.cardHolderIdNo.replace(/[^0-9]/gi, '').length;
			params.cardHolderIdType = _length === 11 ? 'CPF' : 'CNPJ';
			params.cardCountry = values.cardCountry || cardCountry;
			params.cardCity = values.cardCity || cardCity;
			params.cardLine1 = values.cardLine1 || cardLine1;
			params.cardLine2 = values.cardLine2 || cardLine2;
			params.cardState = values.cardState || cardState;
			params.cardPostcode = values.cardPostcode || cardPostcode;
			params.cardDistrict = values.cardDistrict || cardDistrict;
			// 巴西指纹采集
			params.sessionId = sessionStorage.getItem('sessionId') || '';
		}

		if (radioValue === 'QPT') {
			// 调用国内银行正则表达式
			const bankInfo = bankCardAttribution(params.cardNo);
			const cardType = bankInfo?.cardType || ''; // 借记卡还是贷记卡(C或者D) 识别到就传正常值，识别不到就传空
			params.cardType = cardType;
			for (let i = 0; i < payments.length; i++) {
				if (payments[i].paymentMethod === 'QPT') {
					params.cardBrand = payments[i].cardBrands[0];
				}
			}
		}
		if (radioValue === 'KON' || radioValue === 'PEZ') {
			params.firstName = values.firstName && values.firstName.trim(); // 去除卡姓名前后空格
			params.lastName = values.lastName && values.lastName.trim(); // 去除卡姓名前后空格
			params.paymentType = localStorage.getItem('paymentMethod').toUpperCase();
		}

		if (radioValue === 'KBA') {
			params.firstName = values.firstName && values.firstName.trim(); // 去除卡姓名前后空格
			params.lastName = values.lastName && values.lastName.trim(); // 去除卡姓名前后空格
			params.paymentType = localStorage.getItem('paymentMethod').toUpperCase();
			params.postCode = values.cardPostcode && values.cardPostcode.trim() || null;// 去除前后空格    
			params.city = values?.cardCity || null;
			params.country = values?.cardCountry || null;
			params.streetAddress = values.cardLine1 && values.cardLine1.trim() || null;// 去除前后空格    
			delete params.cardPostcode;
			delete params.cardCity;
			delete params.cardCountry;
			delete params.cardLine1;
		}

		let type = radioValue.toLowerCase();

		if (ALIPAY_TYPE.indexOf(radioValue) != -1) {
			// 支付接口参数
			params = {
				terminalType: isMobileView ? 'WAP' : 'WEB',
				paymentType: radioValue.toLocaleLowerCase(),
			}
			type = 'offline'
		}

		if (WAFFO_TYPE.indexOf(radioValue) != -1 ) {
			// 支付接口参数
			params = {
				terminalType: isMobileView ? 'WAP' : 'WEB',
				paymentType: radioValue.toLocaleLowerCase(),
			}
			type = 'offline'
		}

		//微信直连支付方式
		if (WXHK_TYPE.indexOf(radioValue) != -1 ) {
			params = {
				terminalType: isMobileView ? 'WAP' : 'WEB',
				paymentType: radioValue.toLocaleLowerCase(),
			}
			type = 'offline'
		}


		if (radioValue === "AFTERPAY") {
			// 支付接口参数
			params = {
				email: values.email && values.email.trim(),//客户邮箱
				firstName: values.firstName && values.firstName.trim(),//客户名
				lastName: values.lastName && values.lastName.trim(),//客户姓
				phoneNumber: values.phoneNumber && values.phoneNumber.trim(),//客户电话号
				paymentType: radioValue.toLocaleLowerCase(),
				postCode: initData?.cardPostcode || "" ,//邮编
				city: initData?.cardCity || "",//城市
				country: initData?.cardCountry || "" ,//国家
				streetAddress: initData?.cardLine1 || "" ,//地址
				district: initData?.cardDistrict || "" ,//区
				state: initData?.cardState || "" ,//州
				houseNumber: initData?.cardLine2 || ""  ,//门牌号
				terminalType: isMobileView ? 'WAP' : 'WEB',
			}
			params = filterEmptyValues(params)
			type = 'offline'
		}

		console.log(params);

		// 卡号去除空格
		if(Boolean(values.cardNo)){
		   params.cardNo = values.cardNo.replace(/\s*/g, '');
		}
		

		//风控指纹获取sessionId,和后端约定为riskDeviceId
		if (getSessionId()) {
			params.riskDeviceId = getSessionId();
		}

		// console.log('发送请求');
		// console.log(params);

		// return;
		// 加密
		const pubKey = new NodeRSA(myPublicKeyRef.current, 'pkcs8-public');
		const newParams = JSON.parse(JSON.stringify(params));
		// 只有非生产才打印params参数
		if (getEnv() !== 'production') {
			console.log(getEnv() + 'params', params);
		}

		pubKey.setOptions({
			encryptionScheme: 'pkcs1',
		}); // 必须得加，要和java加密解密统一
		const encrypted = pubKey.encrypt(newParams, 'base64');
		// 加密后的参数

		const paramsEncrypted = {
			encrypted,
			token: myTokenRef.current,
		};
		setLoading(true);
		/***
		 * KON/PEZ 走offline
		 * http://192.168.136.22:3000/mock/95/payment/offline/info/{key}
		 */
		if (type === 'kon' || type === 'pez' || type === 'kba') {
			type = 'offline'
		}
		const startTime = new Date().getTime();

		// setType(type);
		// 请求,并且动态获取code码来调整red
		// handleFormSubmit(key, paramsEncrypted);
		const res = await CommonHandleSubmit(
			props,
			key,
			paramsEncrypted,
			resData,
			setLoading,
			isMobileView,
			type,
		);
		if (res && (res.code === 600001 || res.code === 600002)) {
			const resNext = await getInitCardInfo(type, key);
			myTokenRef.current = resNext && resNext.data && resNext.data.token;
			myPublicKeyRef.current = resNext && resNext.data && resNext.data.publicKey

			onFinish(values)
		}

		// 判断支付返回的code，是否已经定义，包含了code和declineCode
		reportEventToMonitor(`异常码报警(cashier_exception_code): declineCode=${res?.data?.declineCode || res?.code},未找到; 支付接口url=/payment/type/payflow/${key};`, 'CODE', res?.data?.declineCode || res?.code || 'P900')

		
		const endTime = new Date().getTime();
		const consumedTime = endTime - startTime;


		// 接口耗时报警,超过10秒
		consumedTime >= 10000 && reportEventToMonitor(`接口耗时报警(cashier_interface_time): time=${consumedTime}ms; 支付接口url=/payment/type/payflow/${key};`)



		if (radioValue === 'QPT') {
			// 短信弹出窗
			let validateKey = res?.data?.validateKey;
			let actualPaymentAmount = res?.data?.actualPaymentAmount;
			let actualPaymentCurrencySymbol = res?.data?.actualPaymentCurrencySymbol;
			let actualPaymentCurrency = res?.data?.actualPaymentCurrency;
			if (validateKey) {
				setLoading(false);
				setMsgModalCardNo(params.cardNo);
				setIsModalVisible(true);
				setValidateKey(validateKey);
				setMyActualPaymentAmount(actualPaymentAmount);
				setMyActualPaymentCurrencySymbol(actualPaymentCurrencySymbol);
				setMyActualPaymentCurrency(actualPaymentCurrency);
				const phoneNumber = form.getFieldValue('phoneNumber');
				setMsgModalPhoneNum(phoneNumber);
			}
		}

		if (res && res.code !== 200000) {
			setMyLastResponseCode(res.code);
		}


		if (res && res.code === 200000) {
			let validateKey = res?.data?.validateKey;
			// 银联支付，并且不需要返回validateKey就直接支付成功的情况
			// 如果支付方式为PEZ， KBA， KON，直接跳转三方链接
			// 如果支付方式为PIX、BOL，则跳转前端pix和bol页面

			if (res.data.paymentStatus === 'WP') {
				if ((radioValue === 'QPT' && !validateKey) || radioValue == 'ICR') {
					setPayflowRes(res);
				} else if (isDirectJumpOrPcRedirectType(radioValue, isMobileView)) {
					console.log('alipay PC端接口出参报警');
					!Boolean(res?.data?.redirectUrl) && reportEventToMonitor(`PC端接口出参报警(cashier_parameter_output): redirectUrl不存在; 支付结果接口url=/payment/offline/payflow/${key};`)

					if (res.data.redirectUrl) {
						window.location.href = res.data.redirectUrl
					}
				} else if (isMobileRedirectType(radioValue, isMobileView)) {
					console.log('alipay移动端接口出参报警');
					!Boolean(res?.data?.redirectUrl) && reportEventToMonitor(`alipay移动端接口出参报警(cashier_parameter_output): redirectUrl不存在; 支付结果接口url=/payment/offline/payflow/${key};`)

					// 如果返回的是链接，则需要跳转到in-payment页面轮询
					if (res.data.redirectUrl) {
						sessionStorage.setItem('fromLink', true)
						window.location.href = `${origin}/in-payment?key=${key}&fromLink=true&paymentMethod=${radioValue}&redirectLink=${encodeURIComponent(res.data.redirectUrl)}`
					}
				} else if (radioValue === 'PIX' || radioValue === 'BOL') {
					console.log('pix接口出参报警');
					!Boolean(res?.data?.redirectUrl) && reportEventToMonitor(`pix/bol接口出参报警(cashier_parameter_output): redirectUrl不存在; 支付结果接口url=/payment/${radioValue}/payflow/${key};`)
					paySuccussHref(res.data.redirectUrl, res.data.invoiceId, resData, type, key, res);
				} else {
					checkPolling()
				}
			} else if (res.data.paymentStatus === 'PS' || res.data.paymentStatus === 'PP') {
				checkPolling()
			} else if (res.data.paymentStatus === 'PF') {
				let returnData = res.data;
				const useData = {
					code: returnData.declineCode || '',
					message: returnData.errorMessage || '',
					...returnData
				}
				CommonError(props, isMobileView, setLoading, useData);
			}
		}
	};

	const filterEmptyValues = (obj) => {
		return Object.keys(obj).filter(key => obj[key] != null && obj[key] !== '').reduce((acc, key) => {
			acc[key] = obj[key];
			return acc;
		}, {});
	}

	const onFinishFailed = values => {
		console.log('error values', values);

		// todo 调用Address,很关键，不然展开不了未填写的地址信息
		setAddressRefChange(addressRef);
		setValidateTrigger('onChange');
	};
	// 表单验证错误，弹出地址选择信息
	const setAddressRefChange = cref => {
		if (!_.isEmpty(cref.current)) {
			cref.current.clickEdit();
		}
	};

	const fillFormCountryChange = (cref, country) => {
		if (!_.isEmpty(cref.current)) {
			cref.current?.fillFormCountryChange(country);
		}
	};

	const fillFormCountryCall = (country) => {
		let paymentMethod = localStorage.getItem('paymentMethod')
		if (paymentMethod === 'kba') {
			setAddressRefChange(addressRef);
			fillFormCountryChange(addressRef, country);
			setValidateTrigger('onChange');
		}
	}

	const getExchangeRateData = (data) => {
		setPayActualPaymentAmount(data && data.amount || '0.00');
		setPayActualPaymentCurrency(data.targetCurrencyName);
	}

	const onChangeRadio = e => {
		// setPayflowRes({ code: 1234 });
		console.log('radio checked', e.target.value);
		setRadioValue(e.target.value);
		let type = e.target.value.toLowerCase();
		if (e.target.value === 'GOOGLEPAY') {
			setIsButtonVisibleGP(null);
		}
		/***
		 * KON/PEZ 走offline
		 * http://192.168.136.22:3000/mock/95/payment/offline/info/{key}
		 */
		// if(type === 'kon' || type ==='pez'){
		// 	type = 'offline';
		// }
		localStorage.setItem('paymentMethod', type)
		setType(type);
		fetchInitData(type, true);

		gtag(`${showDomain}支付页面`, [new Date() + '勾选' + type]);
		gtag(`${showDomain}支付页面`, ['勾选' + type]);
		gtag(`定制支付页面`, ['勾选' + type]);
	};


	const submitForm = function () {
		setTimeout(function () {
			if (btnRef.current) {
				btnRef.current.click()
			}
		}, 1000)
	}


	const getForm = function () {
		// 动态生成表单数据
		// const order = { a: 'aa', b: 'bb' };
		// const header = { c: 'cc', d: 'dd' };
		let orderArray = []
		let bodyArray = []
		// for (let obj1 in order) {
		//   orderArray.push(obj1)
		// }
		for (let obj2 in body) {
			bodyArray.push(obj2)
		}
		let html = (
			<form
				action={returnUrl}
				// action="https://www.baidu.com"
				method={method}
				// encType="multipart/form-data"
				style={{ display: 'none' }}
			>
				{/* {orderArray.map(val => {
          return <input type="text" key={val} value={order[val]} name={val} />
        })} */}
				{bodyArray.map(val => {
					return <input type="text" key={val} value={body[val]} name={val} />
				})}
				<input type="submit" value="Submit" ref={btnRef} />
			</form>
		)
		return html
	}

	const checkPaymentResult = async () => {
		// 支付结果计时
		const startTime = new Date().getTime();

		const res = await paymentResultQuery(key);

		const endTime = new Date().getTime();
		const consumedTime = endTime - startTime;

		// 初始化接口耗时报警,超过10秒
		consumedTime >= 5000 && reportEventToMonitor(`接口耗时报警(cashier_interface_time): time=${consumedTime}ms; 支付结果接口url=/payment/payresult/info/${key};`)
		
		if (res && res.data) {
			let order_status = res.data?.paymentStatus

			setOrderStatus(order_status)
			// 支付成功或者失败，但是有返回商户的重定向地址
			if (order_status === 'PS') {

				
				!res?.data?.returnUrl && reportEventToMonitor(`接口出参报警(cashier_parameter_output): returnUrl不存在; 支付结果接口url=/payment/payresult/info/${key};`)

				Modal.warning({
					content: formatMessage({ id: 'ga-checkout.error-200100' }),
					okText: intl.formatMessage({ id: 'ga-checkout.got-it' }),
					onOk() {
						// 删除缓存
						sessionStorage.removeItem('number')
						sessionStorage.removeItem('method')
						sessionStorage.removeItem('date')
						sessionStorage.removeItem('name')
						if (res.data.returnUrl) {
							setReturnUrl(res.data.returnUrl)
							setBody(res.data.requestBody)
							setMethod(res.data.requestMethod)
							// 延时等待后跳转到成功页面
							setTimeout(() => {
								submitForm()
							}, 300)
							return;
						} else {
							Router.push('/success?errorCode=200100')
							return
						}
					}
				})
			}
		}
	}

	const checkPolling = async () => {
		const res = await paymentPollingQuery(key)

		if (res && res.data) {
			let order_status = res.data?.paymentStatus
			// 等待支付，轮询
			if (order_status === 'WP' || order_status === 'IN' || order_status === 'PP') {

				// 针对线下支付时，直接跳转到三方链接
				if (res.data.redirectUrl) {
					window.location.href = res.data.redirectUrl
				} else {
					checkPolling()
					return
				}
			}
			// 超时
			if (order_status === 'PE') {
				Router.push(`/fail?code=408001&trace_id=${res?.trace_id}`)
				return
			}
			// 支付成功或者失败，但是有返回商户的重定向地址
			if (order_status === 'PS' && res.data.returnUrl) {

				if ((sessionStorage.getItem('llpayReferrer') || '').indexOf('acquiring.lianlianpay.com') != -1 ||
					(document.querySelector('head meta')?.content || '').indexOf('acquiring.lianlianpay.com') != -1 ||
					(sessionStorage.getItem('llpayReferrer') || '').indexOf('localhost:2029') != -1) {
					
					window.location.href = `/success?redirectUrl=${encodeURIComponent(res?.data?.returnUrl)}`;

				} else { 
					// 删除缓存
					sessionStorage.removeItem('number')
					sessionStorage.removeItem('method')
					sessionStorage.removeItem('date')
					sessionStorage.removeItem('name')
					// 删除缓存
					setReturnUrl(res.data.returnUrl)
					setBody(res.data.requestBody)
					setMethod(res.data.requestMethod)
					// 延时等待后跳转到成功页面
					setTimeout(() => {
						submitForm()
					}, 3000)

				}

			}
			// 支付成功，无返回商户的重定向地址
			if (order_status === 'PS' && !res.data.returnUrl) {
				// 删除缓存
				sessionStorage.removeItem('number')
				sessionStorage.removeItem('method')
				sessionStorage.removeItem('date')
				sessionStorage.removeItem('name')
				Router.push('/success')
				return
			}
			// 支付失败，无返回商户的重定向地址
			if (order_status === 'PF') {
				let returnData = res.data;
				const useData = {
					code: returnData.declineCode,
					message: returnData.errorMessage,
					...returnData
				}
				CommonError(props, isMobileView, setLoading, useData);
			}
		} else if (res.code === 600020) {
			checkPolling()
			return
		} else {
			Router.push(`/fail?code=${res.code}&trace_id=${res?.trace_id}`)
		}
	}

	const bankList = function (item) {
		console.log(item);
		let bankType = [];
		for (let i = 0; i < payments.length; i++) {
			if (payments[i].paymentMethod === item) {
				bankType = payments[i].cardBrands;
			}
		}

		let html = (
			<div className={`h5-card-elements-list h5-card-elements-list-${item}`}>
				<div style={{ right: 0, position: 'relative', top: '-4px' }}>
					{!_.isEmpty(bankType) &&
						bankType.map((val, k) => {
							if ((item === 'ICR' || item === 'LCR') || item === 'KON') {
								if (k < 3 && item != 'KON') {
									return getContainer(val);
								} else if (k < 2 && item === 'KON') { 
									return getContainer(val);
								}
							} else {
								return getContainer(val);
							}
						})}
					{
						bankType?.length > 3 && (item === 'ICR' || item === 'LCR') ? bankMore(bankType, 3) : ''
					}
					{ 
						bankType?.length > 2 && item === 'KON' ? bankMore(bankType, 2) : ''
					}
				</div>
			</div>
		);
		return html;
	};



	const bankMore = function (bankType, length) {
		const moreBank = bankType.slice(length)
		console.log(moreBank);
		return (
			<Popover content={
				<div className={'more-bank-logo'}>
					{bankMoreContent(moreBank)}
				</div>
			} title="" placement="topRight">
				<Button>+{bankType.length - length}</Button>
			</Popover>
		)
	}

	const bankMoreContent = function (moreBank) {
		// return 1234567
		console.log(moreBank);
		return moreBank.map((val, k) => {
			return getContainer(val)
		})
	}

	const getContainer = function (val) {
		const prefix = 'h5pc-card-paid-list-';
		const suffix = '-actived';
		const iconScale = 'h5pc-card-paid-icon-scale';
		const bankActived = prefix + val + suffix;
		return (
			<div
				className={classnames({
					[iconScale]: true,
					[bankActived]: true,
				})}
				key={val}
			></div>
		);
	};

	const notSupportRender = () => {
		return (
			<div style={{ color: "rgba(0, 0, 0, 0.45)" , fontSize: '14px', padding: '10px 0px' }}>
				<InfoCircleOutlined style={{ color: "#ffe58f" }}/>
				<span style={{ marginLeft: '5px' }}>请在移动端打开!</span>
			</div>
		)
	}

	/** 收银台钱包支付金额（与 Google Pay / Apple Pay SDK 约定） */
	const walletTransactionInfo = {
		totalPrice: String(
			ablePaymentCurrencyListBoolean
				? payActualPaymentAmount || ''
				: initData?.actualPaymentAmount ?? actualPaymentAmount ?? '',
		),
		currencyCode: ablePaymentCurrencyListBoolean
			? payActualPaymentCurrency || ''
			: initData?.actualPaymentCurrency ?? actualPaymentCurrency ?? '',
	};

	useEffect(() => {
		if (!key) {
			return undefined;
		}
		const hasApplePay = payments?.some(p => p.paymentMethod === 'APPLEPAY');
		if (!hasApplePay) {
			return undefined;
		}
		const onlyApplePay =
			payments.length === 1 && payments[0]?.paymentMethod === 'APPLEPAY';
		if (radioValue !== 'APPLEPAY' && !onlyApplePay) {
			return undefined;
		}
		let cancelled = false;
		(async () => {
			try {
				const res = await getCashierApplePayInfo(key);
				if (cancelled) {
					return;
				}
				if (res?.code === 200000 && res?.data?.applePayConfigInfoBean) {
					setApplePayConfigInfoBeanData(res.data.applePayConfigInfoBean);
					if (res.data.publicKey) myPublicKeyRef.current = res.data.publicKey;
					if (res.data.token) myTokenRef.current = res.data.token;
				} else {
					setApplePayConfigInfoBeanData({});
					if (res?.message) {
						message.error(res.message);
					}
				}
			} catch (e) {
				if (!cancelled) {
					setApplePayConfigInfoBeanData({});
				}
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [key, radioValue, payments]);

	/** 仅一种钱包方式时，收银台数据异步到达后需同步当前选中方式，否则 radioValue 可能仍为初始 undefined */
	useEffect(() => {
		if (
			payments?.length === 1 &&
			payments[0]?.paymentMethod === 'GOOGLEPAY' &&
			radioValue !== 'GOOGLEPAY'
		) {
			setRadioValue('GOOGLEPAY');
			setType('googlepay');
			localStorage.setItem('paymentMethod', 'googlepay');
		}
		if (
			payments?.length === 1 &&
			payments[0]?.paymentMethod === 'APPLEPAY' &&
			radioValue !== 'APPLEPAY'
		) {
			setRadioValue('APPLEPAY');
			setType('applepay');
			localStorage.setItem('paymentMethod', 'applepay');
		}
	}, [payments, radioValue]);

	useEffect(() => {
		if (!key) {
			return undefined;
		}
		const hasGooglePay = payments?.some(p => p.paymentMethod === 'GOOGLEPAY');
		if (!hasGooglePay) {
			return undefined;
		}
		const onlyGooglePay =
			payments.length === 1 && payments[0]?.paymentMethod === 'GOOGLEPAY';
		if (radioValue !== 'GOOGLEPAY' && !onlyGooglePay) {
			return undefined;
		}
		let cancelled = false;
		(async () => {
			try {
				const res = await getCashierGooglePayInfo(key);
				if (cancelled) {
					return;
				}
				if (res?.code === 200000 && res?.data?.googlePayConfigInfoBean) {
					setGooglePayConfigInfoBean(res.data.googlePayConfigInfoBean);
					if (res.data.publicKey) myPublicKeyRef.current = res.data.publicKey;
					if (res.data.token) myTokenRef.current = res.data.token;
				} else {
					setGooglePayConfigInfoBean(null);
					if (res?.message) {
						message.error(res.message);
					}
				}
			} catch (e) {
				if (!cancelled) {
					setGooglePayConfigInfoBean(null);
				}
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [key, radioValue, payments]);

	const handleReadyToPayGoogleChange = useCallback(
		value => {
			const { isReadyToPay, isButtonVisible } = value;
			setIsButtonVisibleGP(isButtonVisible);
			if (!isButtonVisible) {
				message.error(
					formatMessage({ id: 'ga-checkout.googlepay.isReadyToPay-false-tip' }),
				);
				return;
			}
			if (!isReadyToPay) {
				message.error(
					formatMessage({ id: 'ga-checkout.googlepay.isReadyToPay-false-tip' }),
				);
			}
		},
		[formatMessage],
	);

	const handleCashierApplePayAuthorized = useCallback(
		async (paymentData, session) => {
			console.log("applepay authorized success", paymentData, session);

			if (!myPublicKeyRef.current) {
				message.warning(formatMessage({ id: 'ga-checkout.netword-slow' }));
				try { session?.completePayment({ status: ApplePaySession.STATUS_FAILURE }); } catch (e) { console.error(e); }
				return;
			}

			const params = {
				channelCode: applePayConfigInfoBeanData?.channelCode,
				paymentToken: paymentData,
			};

			if (getSessionId()) {
				params.riskDeviceId = getSessionId();
			}

			if (getEnv() !== 'production') {
				console.log(getEnv() + 'params', params);
			}

			const pubKey = new NodeRSA(myPublicKeyRef.current, 'pkcs8-public');
			pubKey.setOptions({ encryptionScheme: 'pkcs1' });
			const encrypted = pubKey.encrypt(JSON.parse(JSON.stringify(params)), 'base64');
			const paramsEncrypted = { encrypted, token: myTokenRef.current };

			setLoading(true);
			const res = await paymentPayflow('applepay', key, paramsEncrypted);

			if (!res) {
				setLoading(false);
				try { session?.completePayment({ status: ApplePaySession.STATUS_FAILURE }); } catch (e) { console.error(e); }
				return;
			}

			if (res.code === 600001 || res.code === 600002) {
				const resNext = await getInitCardInfo('applepay', key);
				myTokenRef.current = resNext?.data?.token;
				myPublicKeyRef.current = resNext?.data?.publicKey;
				handleCashierApplePayAuthorized(paymentData, session);
				return;
			}

			if (res.code === 200000) {
				if (res.data?.paymentStatus === 'WP' || res.data?.paymentStatus === 'PS' || res.data?.paymentStatus === 'PP') {
					if (res.data?.paymentStatus === 'PS') {
						try { 
							session?.completePayment({ status: ApplePaySession.STATUS_SUCCESS }); 
						} catch (e) { 
							console.error(e); 
						}
					}
					checkPolling();
				} else if (res.data?.paymentStatus === 'PF') {
					try { session?.completePayment({ status: ApplePaySession.STATUS_FAILURE }); } catch (e) { console.error(e); }
					const useData = {
						code: res.data.declineCode || '',
						message: res.data.errorMessage || '',
						...res.data,
					};
					CommonError(props, isMobileView, setLoading, useData);
				}
			} else {
				try { session?.completePayment({ status: ApplePaySession.STATUS_FAILURE }); } catch (e) { console.error(e); }
				CommonError(props, isMobileView, setLoading, res);
			}
		},
		[key, props, isMobileView, checkPolling, applePayConfigInfoBeanData, formatMessage],
	);
    
	const handleCashierGooglePayLoadPaymentData = useCallback(async (paymentRequest) => {
		const { paymentMethodData } = paymentRequest;
		const { tokenizationData } = paymentMethodData;
		console.log("谷歌支付token", tokenizationData);

		if (!myPublicKeyRef.current) {
			message.warning(formatMessage({ id: 'ga-checkout.netword-slow' }));
			return;
		}

		const params = {
			channelCode: googlePayConfigInfoBean?.channelCode,
			paymentToken: tokenizationData.token,
		};

		if (getSessionId()) {
			params.riskDeviceId = getSessionId();
		}

		if (getEnv() !== 'production') {
			console.log(getEnv() + 'params', params);
		}

		const pubKey = new NodeRSA(myPublicKeyRef.current, 'pkcs8-public');
		pubKey.setOptions({ encryptionScheme: 'pkcs1' });
		const encrypted = pubKey.encrypt(JSON.parse(JSON.stringify(params)), 'base64');
		const paramsEncrypted = { encrypted, token: myTokenRef.current };

		setLoading(true);
		const res = await paymentPayflow('googlepay', key, paramsEncrypted);

		if (!res) {
			setLoading(false);
			return;
		}

		if (res.code === 600001 || res.code === 600002) {
			const resNext = await getInitCardInfo('googlepay', key);
			myTokenRef.current = resNext?.data?.token;
			myPublicKeyRef.current = resNext?.data?.publicKey;
			handleCashierGooglePayLoadPaymentData(paymentRequest);
			return;
		}

		if (res.code === 200000) {
			if (res.data?.paymentStatus === 'WP' || res.data?.paymentStatus === 'PS' || res.data?.paymentStatus === 'PP') {
				checkPolling();
			} else if (res.data?.paymentStatus === 'PF') {
				const useData = {
					code: res.data.declineCode || '',
					message: res.data.errorMessage || '',
					...res.data,
				};
				CommonError(props, isMobileView, setLoading, useData);
			}
		} else {
			CommonError(props, isMobileView, setLoading, res);
		}
	}, [key, props, isMobileView, checkPolling, googlePayConfigInfoBean, formatMessage]);

	// 公共的渲染方法
	const commonRender = (item, k) => {
		// console.log(item, radioValue)
		let html;
		if (
			(item === 'ICR' && radioValue === 'ICR') ||
			(item === 'LCR' && radioValue === 'LCR')
		) {
			html = <Card cref={addressRef} />;
		}
		if (
			(item === 'PIX' && radioValue === 'PIX') ||
			(item === 'BOL' && radioValue === 'BOL')
		) {
			/* pix 和 bolete公用方法 */
			html = <PIXBOL cref={addressRef} />;
		}
		if (
			(item === 'KON' && radioValue === 'KON') ||
			(item === 'PEZ' && radioValue === 'PEZ') ||
			(item === 'AFTERPAY' && radioValue === 'AFTERPAY')
		) {
			html = <KPAY cref={addressRef} />;
		}

		if (
			(item === 'KBA' && radioValue === 'KBA')
		) {
			html = <Klarna cref={addressRef} />;
		}


		if (item === 'TRUEMONEY' && radioValue === 'TRUEMONEY') {
			html = <AlipayQrLink cref={addressRef} />;
		}

		if (item === 'ALIPAY_CN' && radioValue === 'ALIPAY_CN') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'ALIPAY_HK' && radioValue === 'ALIPAY_HK') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'DANA' && radioValue === 'DANA') {
			html = <LinkPay cref={addressRef} />;
		}
		if (item === 'BOOST' && radioValue === 'BOOST') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'GCASH' && radioValue === 'GCASH') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'KAKAOPAY' && radioValue === 'KAKAOPAY') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'BPI' && radioValue === 'BPI') {
			html = <LinkPay cref={addressRef} />;
		}
		if (item === 'TNG' && radioValue === 'TNG') {
			html = <AlipayQrLink cref={addressRef} />;
		}
		if (item === 'RABBIT_LINE_PAY' && radioValue === 'RABBIT_LINE_PAY') {
			html = <LinkPay cref={addressRef} />;
		}


		// 迅联
		if (item === 'WECHATPAY' && radioValue === 'WECHATPAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}
		if (item === 'PROMPTPAY' && radioValue === 'PROMPTPAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}
		if (item === 'KRUNGSRIONLINE' && radioValue === 'KRUNGSRIONLINE' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'RABBIT_LINE_PAY' && radioValue === 'RABBIT_LINE_PAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'BUALUANGIBANKING' && radioValue === 'BUALUANGIBANKING' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'MAYBANK' && radioValue === 'MAYBANK' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'CIMBCLICKS' && radioValue === 'CIMBCLICKS' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'MCASH' && radioValue === 'MCASH' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'TNG' && radioValue === 'TNG' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'BOOST' && radioValue === 'BOOST' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'BNI' && radioValue === 'BNI' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'MANDIRI' && radioValue === 'MANDIRI' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'PERMATA' && radioValue === 'PERMATA' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'BRI' && radioValue === 'BRI' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'OVO' && radioValue === 'OVO' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'DANA' && radioValue === 'DANA' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'NOBUBANKQRIS' && radioValue === 'NOBUBANKQRIS' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'AKULAKU_PAYLATER' && radioValue === 'AKULAKU_PAYLATER' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'LINEPAY' && radioValue === 'LINEPAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'PAIDY' && radioValue === 'PAIDY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		if (item === 'PAYCO' && radioValue === 'PAYCO' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}
		if (item === 'NAVERPAY' && radioValue === 'NAVERPAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}
		if (item === 'KAKAOPAY' && radioValue === 'KAKAOPAY' && actionType[k] === 'EVO') {
			html = <Evonet cref={addressRef} />;
		}

		//WAFFO本地支付
		if ((
			(item === 'PAYMAYA' && radioValue === 'PAYMAYA') ||
			(item === 'ZALOPAY' && radioValue === 'ZALOPAY') ||
			(item === 'JKOPAY' && radioValue === 'JKOPAY') ||
			(item === 'GCASH' && radioValue === 'GCASH') ||
			(item === 'GRABPAY' && radioValue === 'GRABPAY') ||
			(item === 'COINSPH' && radioValue === 'COINSPH') ||
			(item === 'TWN_BANK' && radioValue === 'TWN_BANK') ||
			(item === 'NAPASCARD' && radioValue === 'NAPASCARD'))&&
			actionType[k] === 'WAFFO'
		) {
			html = <CommonLink cref={addressRef} prePayment={"waffo"}/>;
		}
		
		if (item === 'VIETQR' && radioValue === 'VIETQR' && actionType[k] === 'WAFFO') {
			html = <CommonQrcode cref={addressRef} prePayment={"waffo"}/>;
		}

		//微信直连支付方式
		if (item === 'WECHATPAY' && radioValue === 'WECHATPAY' && actionType[k] === 'WXHK') {
			html = <CommonQrcodeOrLink cref={addressRef} prePayment={"wxhk"}/>;
		}

		// 收银台 Apple Pay / Google Pay（接口：/payment/{applepay|googlepay}/info/{key}，与 iframe 页隔离）
		if (
			item === 'APPLEPAY' &&
			radioValue === 'APPLEPAY' &&
			applePayConfigInfoBeanData?.merchantIdentifier
		) {
			// 由于苹果支付沙箱环境暂不支持联调，先隐藏该支付方式
			html = (
				<CashierApplePayButton
					cashierKey={key}
					applePayConfigInfoBeanData={applePayConfigInfoBeanData}
					transactionInfo={walletTransactionInfo}
					onCashierApplePayAuthorized={handleCashierApplePayAuthorized}
				/>
			);
		}
		if (item === 'GOOGLEPAY' && radioValue === 'GOOGLEPAY' && googlePayConfigInfoBean) {
			html = (
				<CashierGooglePayButton
					googlePayConfigInfoBean={googlePayConfigInfoBean}
					onReadyToPayGoogleChange={handleReadyToPayGoogleChange}
					isButtonVisibleGP={isButtonVisibleGP}
					transactionInfo={walletTransactionInfo}
					onCashierGooglePayLoadPaymentData={handleCashierGooglePayLoadPaymentData}
				/>
			);
		}

		return (
			<>
				{html ? (
					<div className={`h5pc-group-radio-content-container h5pc-group-radio-content-container-${item}`}>
						<myContext.Provider
							value={{
								form,
								initData,
								cashierData,
								resData,
								radioValue,
								isMobileView,
								type,
								loading,
								actualPaymentAmount: payActualPaymentAmount,
								actualPaymentCurrency: payActualPaymentCurrency,
								publicKey,
								setLoading,
								key,
								token,
								checkPolling,
								orderStatus
							}}
						>
							{html}
						</myContext.Provider>
					</div>
				) : null}
			</>
		);
	};



	
	let radioContainerRender = () => {
		// 如果只有一种支付方式，那么不显示radio
		let radioCheck =
			paymentMethod.length === 1 ? 'h5pc-group-radio-check-none' : '';
		return (
			<Radio.Group
				onChange={onChangeRadio}
				value={radioValue}
				className="h5pc-group-radio"
			>
				{paymentMethod.map((item, k) => {
					return (
						<div className="h5pc-group-radio-f" style={{
							display:
								paymentLen < 5 ? 'block' :
									k < 5 ?
										'block' :
										showMore ?
											'block'
											:
											'none'
						}} key={item} >
							<div className="h5pc-group-radio-f-container">
								<div
									className={`h5pc-group-radio-f-container-content`}
								>
									<div className="h5pc-group-radio-container">
										<Radio
											value={item}
											className={classnames({
												[radioCheck]: true,
											})}
										>
											<div className="h5pc-group-radio-container-title">
												{item === 'QPT' ? 'UnionPay(Credit and Debit card)' : null}
												{item === 'ICR' ? formatMessage({ id: 'ga-checkout.pay-with-card' }) : null}
												{item === 'LCR'
													? formatMessage({ id: 'ga-checkout.credit-card' })
													: null}
												{item === 'PIX' ? 'PIX' : null}
												{item === 'BOL' ? 'Boleto' : null}
												{item === 'KON' ? 'Konbini Store' : null}
												{item === 'PEZ' ? 'Pay-easy' : null}
												{item === 'KBA' ? 'Klarna' : null}

												{item === 'APPLEPAY' ? 'Apple Pay' : null}
												{item === 'GOOGLEPAY' ? 'Google Pay' : null}

												{item === 'ALIPAY_CN' ? 'AlipayCN' : null}
												{item === 'ALIPAY_HK' ? 'AlipayHK' : null}

												{item === 'KAKAOPAY' ? 'Kakao Pay' : null}
												{item === 'GCASH' ? 'Gcash' : null}
												{item === 'DANA' ? 'DANA' : null}
												{item === 'TRUEMONEY' ? 'TrueMoney' : null}
												{item === 'RABBIT_LINE_PAY' ? 'Rabbit Line Pay' : null}
												{item === 'BPI' ? 'BPI' : null}
												{item === 'TNG' ? 'Touch n Go' : null}
												{item === 'BOOST' ? 'Boost' : null}

												{/* 迅联 */}
												{item === 'WECHATPAY' ? 'WeChat Pay' : null}
												{item === 'PROMPTPAY' ? 'Prompt Pay' : null}
												{item === 'KRUNGSRIONLINE' ? 'Krungsri Online' : null}
												{item === 'BUALUANGIBANKING' ? 'Bualuang iBanking' : null}
												{item === 'MAYBANK' ? 'Maybank' : null}
												{item === 'CIMBCLICKS' ? 'CIMB Clicks' : null}
												{item === 'MCASH' ? 'Mcash' : null}
												{item === 'BNI' ? 'BNI' : null}
												{item === 'MANDIRI' ? 'Mandiri' : null}
												{item === 'PERMATA' ? 'Permata' : null}
												{item === 'BRI' ? 'BRI' : null}
												{item === 'OVO' ? 'OVO' : null}
												{item === 'NOBUBANKQRIS' ? 'Nobu Bank QRIS' : null}
												{item === 'AKULAKU_PAYLATER' ? 'Akulaku' : null}
												{item === 'PAYCO' ? 'PAYCO' : null}
												{item === 'NAVERPAY' ? 'Naver Pay' : null}
												{item === 'PAIDY' ? 'Paidy' : null}
												{item === 'LINEPAY' ? 'Line Pay' : null}


												{item === 'AFTERPAY' ? 'Afterpay' : null}

												{/* WAFFO本地支付 */}
												{item === 'PAYMAYA' ? 'Maya' : null}
												{item === 'GRABPAY' ? 'GrabPay' : null}
												{item === 'COINSPH' ? 'Coins.ph' : null}
												{item === 'TWN_BANK' ? 'TWN BANK' : null}
												{item === 'JKOPAY' ? 'JKO PAY' : null}
												{item === 'ZALOPAY' ? 'Zalopay' : null}
												{item === 'VIETQR' ? 'VietQR' : null}
												{item === 'NAPASCARD' ? 'Napas Card' : null}
											</div>
											{item === 'PIX' || item === 'BOL' ? (
												<div className="h5pc-group-radio-container-icon">
													<div className="h5-card-elements-list">
														<div style={{ right: 0 }}>
															{/* <img
                            style={{ height: '18px' }}
                            src={`/static/images/${item.toLocaleLowerCase()}.png`}
                          ></img> */}
															<div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
														</div>
													</div>
												</div>
											) :
												// 针对Alipay+的支付方式
												[
													'TRUEMONEY',
													'ALIPAY_CN',
													'ALIPAY_HK',
													'DANA',
													'GCASH',
													'TNG',
													'RABBIT_LINE_PAY',
													'BPI',
													'KAKAOPAY',
													'BOOST'
												].includes(item) && actionType[k] != 'EVO' && actionType[k] != 'WAFFO' ? (
													<div className="h5pc-group-radio-container-icon">
														<div className="h5-card-elements-list">
															<div style={{ right: 0, display: 'flex', alignItems: 'center' }}>
																<div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
																<span style={{ margin: '0px 0px 0px 10px' }}>|</span>
																<div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-alipay-actived`}></div>
															</div>
														</div>
													</div>
												)
													:
													// 迅联支付方式
													[
														'WECHATPAY',
														'PROMPTPAY',
														'KRUNGSRIONLINE',
														'RABBIT_LINE_PAY',
														'BUALUANGIBANKING',
														'MAYBANK',
														'CIMBCLICKS',
														'MCASH',
														'TNG',
														'BOOST',
														'BNI',
														'MANDIRI',
														'PERMATA',
														'BRI',
														'OVO',
														'DANA',
														'NOBUBANKQRIS',
														'AKULAKU_PAYLATER',
														'LINEPAY',
														'PAIDY',
														'PAYCO',
														'NAVERPAY',
														'KAKAOPAY'
													].includes(item) && actionType[k] === 'EVO' ? (
														<div className="h5pc-group-radio-container-icon">
															<div className="h5-card-elements-list">
																<div style={{ right: 0, display: 'flex', alignItems: 'center' }}>
																	<div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
																</div>
															</div>
														</div>
													):
													// 微信直连支付方式
													[
														'WECHATPAY'
													].includes(item) && actionType[k] === 'WXHK' ? (
														<div className="h5pc-group-radio-container-icon">
															<div className="h5-card-elements-list">
																<div style={{ right: 0, display: 'flex', alignItems: 'center' }}>
																	<div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
																</div>
															</div>
														</div>
													) : 
													// WAFFO本地支付方式
													[
														'GCASH',
														'COINSPH',
														'GRABPAY',
														'PAYMAYA',
														'JKOPAY',
														'TWN_BANK',
														'ZALOPAY',
														'NAPASCARD',
														'VIETQR'
													].includes(item) && actionType[k] === 'WAFFO' ? (
														<div className="h5pc-group-radio-container-icon">
													        <img
																style={{ height: '20px' }}
																src={`/static/images/waffo/${item.toLocaleLowerCase()}.png`}
															></img>
													  </div>
													):['AFTERPAY', 'KBA'].indexOf(item)>-1 ? (<>
													<div className="h5pc-group-radio-container-icon" style={{ marginTop: '-5px'}}>
													        <img
																style={{ height: '26px' }}
																src={`/static/images/${item.toLocaleLowerCase()}.png`}
															></img>
													  </div>													   
													</>) 
													: ['APPLEPAY', 'GOOGLEPAY'].includes(item) ? (
														<div className="h5pc-group-radio-container-icon" style={{ marginTop: '-5px' }}>
															<img
																style={{ height: '26px' }}
																src={
																	item === 'APPLEPAY'
																		? '/static/images/apple_pay.svg'
																		: '/static/images/google_pay.png'
																}
															/>
														</div>
													) : (
													<div className={`h5pc-group-radio-container-icon`}>
														{bankList(item)}
													</div>
												)}

										</Radio>
									</div>
								</div>
								{item === 'QPT' && radioValue === 'QPT' ? (
									<div className="h5pc-group-radio-f-container-content">
										<div className="h5pc-group-radio-content-container">
											<myContext.Provider
												value={{
													form,
													initData,
													bankCode,
													setBankCode,
													isMobileView,
													resData
												}}
											>
												<UnionPay />
											</myContext.Provider>
											<myContext.Provider
												value={{
													initData,
													isMobileView,
													key,
													msgModalCardNo,
													bankCode,
													isModalVisible,
													setIsModalVisible,
													loading,
													setLoading,
													validateKey,
													setValidateKey,
													myActualPaymentAmount,
													myActualPaymentCurrencySymbol,
													myActualPaymentCurrency,
													msgModalPhoneNum,
												}}
											>
												<MessageModal />
											</myContext.Provider>
										</div>
									</div>
								) : null}
								{/* 公共的渲染方法 */}
								{commonRender(item, k)}
							</div>
						</div>
					);
				})}
			</Radio.Group>
		);
	};

	return (
		<Container>
			<div className="h5pc-cashier vh5pc-cashier" ref={containerRef}>
				<myContext.Provider value={{ showDomain, isMobileView, key, resData, cashierData }}>
					{
						h5OrWeb === 'H5' && <ThemeMobile />

					}
				</myContext.Provider>

				<div className="vh5pc-cashier-container">
					{
						h5OrWeb === 'H5' &&
							<myContext.Provider value={{ showDomain, isMobileView, key, resData, cashierData, merchantTheme }}>
								<div className="vh5pc-cashier-container-right">
									{
										// ablePaymentCurrencyList || merchantServiceChargeModel === 'DCC' || orderServiceChargeRate ?
											// <ProductsZD />
											// :
											<ProductsInfo />	
									}
								</div>
							</myContext.Provider>
					}

					{
						h5OrWeb === 'H5' ?
							''
							:
							<myContext.Provider value={{ showDomain, isMobileView, key, resData, cashierData, merchantTheme }}>
								<div className="vh5pc-cashier-container-right">
									{
										// ablePaymentCurrencyList || merchantServiceChargeModel === 'DCC' || orderServiceChargeRate ?
										// 	<ProductsZD />
										// 	:
										<div className='vh5pc-cashier-container-right-product' style={{height:'20px'}}>
											<span
												onClick={() =>
													CommonHandleCancelPayment(props, resData, key, isMobileView, showDomain)
												}
											>
												<Image src={`/static/images/back.png`} width={18} height={14} />  
											</span>
											<ProductsInfo />
										</div>
									}
									
								</div>
							</myContext.Provider>
					}

					<div className="vh5pc-cashier-container-card">
						<div className="vh5pc-cashier-container-left">
							{ 
								!isMobileView &&
									<div style={{paddingBottom: '24px'}}>
										<div className="h5pc-order-info-detail">
											<div className="h5pc-cashier-logo-container-title">
												{formatMessage({ id: 'ga-checkout.payment' })}
											</div>
										</div>
									</div>

									
							}
							

							{!_.isEmpty(initData) ? (
								<Form
									form={form}
									onFinish={onFinish}
									onFinishFailed={onFinishFailed}
									validateTrigger={validateTrigger}
									requiredMark={false}
									layout="vertical"
									scrollToFirstError
									initialValues={{
										// cardBrand: 'visa',
										// cardNo: '6212 2612 0203 9573 572',
										// cardName: '俞梦泽',
										// phoneNumber: '15088619814',
										// idNo: '330821198812054011',
										firstName: initData?.firstName || '',
										lastName: initData?.lastName || '',
										phoneNumber: initData?.phoneNumber || '',
										cardHolderIdNo: '',
										cardName,
										email,
										cardCountry,
										cardLine1,
										cardLine2,
										cardCity,
										cardState,
										cardPostcode,
										showDomain
									}}
								>
									{loading ? <LockLoading msg="Processing..." /> : null}
									{
										ablePaymentCurrencyListBoolean ?
											<myContext.Provider
												value={{
													form,
													cashierData,
													resData,
													isMobileView,
													type,
													getExchangeRateData
												}}
											>
												<ExchangeRate />
											</myContext.Provider>
											:
											null
									}
									{radioContainerRender()}
									{
										!showMore && paymentLen > 5 ?
											<div style={{ textAlign: 'center' }}>
												<Button
													style={{ color: '#666', background: 'transparent' }}
													type='text'
													onClick={() => {
														setShowMore(!showMore)
													}}>
													{formatMessage({ id: 'ga-checkout.more.payment' })}
													<DownOutlined />
												</Button>
											</div>
											:
											''
									}
									{/* {getEnv() !== 'production' ? <CommonTestCode form={form} handleAddressCountry={(country) => fillFormCountryCall(country)} /> : ''} */}
									{showEuropeFlag ? (
										<div>
											<div className="company-name">{companyName}</div>
											<div className="company-address">{companyAddress}</div>
										</div>
									) : null}
								</Form>
							) : (
								<div
									style={{
										padding: '0 15px',
										background: '#fff',
										margin: '0 15px',
									}}
								>
									<Skeleton active paragraph={{ rows: 10 }} />
								</div>
							)}
							<myContext.Provider value={{ props, resData, cashierData, key, isMobileView, showDomain, fontColor }}>
								<VFooter />
							</myContext.Provider>

						</div>
					</div>
				</div>
			</div>
			{/*  ----- 风控指纹相关以及页面跳转开始---- */}
			<myContext.Provider
				value={{
					isMobileView,
					key,
					payflowRes,
					resData,
					type,
					setLoading,
					checkPolling
				}}
			>
				<Tds />
			</myContext.Provider>

			{/*  ----- 风控指纹相关以及页面跳转结束 ---- */}

			{returnUrl ? getForm() : ''}

			{/* 内部样式 */}
			<style jsx global>{`
  				/****************** end设置input、button的颜色**********************/
				.vh5pc-cashier .h5pc-float-label-field input:hover,
				.vh5pc-cashier .h5pc-float-label-field input:focus,
				.vh5pc-cashier .h5pc-float-label-field input:active {
						border-color: ${fontColor};
						box-shadow: none;
						color: ${fontColor};
					}

					.vh5pc-cashier .h5pc-float-label-field .my-native-select:focus,
					.vh5pc-cashier .h5pc-float-label-field .my-native-select:hover,
					.vh5pc-cashier .h5pc-float-label-field .my-native-select:active {
						border-color: ${fontColor};
						box-shadow: none;
						color: ${fontColor};
					}

					.vh5pc-cashier .ant-btn-link {
						color: #153b48;
					}

					.vh5pc-cashier .ant-radio:hover .ant-radio-inner {
						border-color: ${fontColor};
					}

					.vh5pc-cashier .ant-radio-checked .ant-radio-inner {
						border-color: ${fontColor || `#0074D5`};
					}

					.vh5pc-cashier .ant-radio-inner::after {
						background-color: ${fontColor || `#0074D5`};
					}
					.vh5pc-cashier .product-lists .ant-menu-item .product-list-left-title-more span {
						font-size: 12px;
						color: ${fontColor};
					  }
					  .vh5pc-cashier .product-lists .ant-menu-item .product-list-left-title-less {
						color: ${fontColor};
						padding: 6px 0 2px 0;
						display: none;
						cursor: pointer;
						width: 28px;
					}
					.vh5pc-cashier .product-lists-bottom-total-price {
						color: ${fontColor};
						// font-weight: bold;
						font-size: 14px;
					}
					.vh5pc-cashier .vh5pc-footer-bottom-container-cancel .h5pc-cashier-logo-container-cancel {
						position: inherit;
						color: ${fontColor};
						font-size: 12px;
						cursor: pointer;
					}
					.vh5pc-cashier .h5pc-submit-btn {
						background: ${mainColor || '#0074D5'};
					}
					.vh5pc-cashier  a{
						color: ${mainColor || '#0074D5'}
					}
					.vh5pc-cashier .h5pc-submit-btn[disabled] {
						border-color: #aaa;
						background: #aaa;
						color: #fff;
					}
					.vh5pc-cashier  .h5pc-address .h5-address-edit{
						border-color: #ddd;
					}
					.vh5pc-cashier  .h5pc-address .h5-address-edit-btn{
						color: ${fontColor};
					}
					.vh5pc-cashier-container-right-card ul li svg,

					.vh5pc-cashier .h5-card-elements-list-ICR button,
					.vh5pc-cashier .h5-card-elements-list-LCR button,
					.vh5pc-cashier .h5-card-elements-list-KON button{
						color: ${mainColor || '#0074D5'};
					}
					.vh5pc-cashier .h5-card-elements-list-ICR button:hover,
					.vh5pc-cashier .h5-card-elements-list-LCR button:hover,
					.vh5pc-cashier .h5-card-elements-list-KON button:hover{

						color: ${mainColor || '#0074D5'};
					}
					.order-products-item-title-more, .order-summary-footer-right-amount{
						color: ${mainColor || '#0074D5'};
					}
					.vh5pc-cashier-mobile-top-cancel{
						color: ${mainColor || '#0074D5'};
					}
      		`}</style>
		</Container>
	);
}

export default injectIntl(CreditCard);
